import { atomWithStorage } from 'jotai/utils';

// Create the sidebar atom with localStorage persistence
export const sidebarCollapsedAtom = atomWithStorage<boolean>(
  '@actegon.gis.sidebar.collapsed',
  false, // Default value when nothing is stored in localStorage
);

export const SIDEBAR_DEFAULT_WIDTH = 256;
export const LAYERS_SIDEBAR_DEFAULT_WIDTH = 288;

export const sidebarWidthAtom = atomWithStorage<number>('@actegon.gis.sidebar.width', SIDEBAR_DEFAULT_WIDTH);
export const layersSidebarWidthAtom = atomWithStorage<number>(
  '@actegon.gis.layersSidebar.width',
  LAYERS_SIDEBAR_DEFAULT_WIDTH,
);
